<template>
  <div
    class="upload-area"
    :class="{ circle: circleBorder }"
    :style="{ height: height, width: width }"
    @dragover.prevent
    @dragleave.prevent
    @drop="onDrop"
  >
    <input
      @change="fileAttached"
      ref="commentUpload"
      type="file"
      style="display:none"
    />
    <div
      class="add-img-wrapper"
      :class="{ circle: circleBorder }"
      @click="$refs.commentUpload.click()"
      v-if="!commentUploadUrl"
    >
      <i class="img-icon" :class="icon"></i>
      <div class="text">{{ text }}</div>
    </div>
    <div class="attached-img-wrapper" v-if="commentUploadUrl">
      <div class="hover-shadow" @click="clearAttachInput">
        <i class="far fa-trash-alt"></i>
      </div>
      <img
        :src="commentUploadUrl"
        class="uploaded-pic"
        :class="{ imageBorder: !circleBorder }"
        alt="slika"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    width: { type: String, default: '100%' },
    height: { type: String, default: '80px' },
    text: { type: String, default: 'Izaberite profilnu sliku zajednice' },
    icon: { type: String, default: 'far fa-image' },
    circleBorder: { type: Boolean, default: false }
  },
  data() {
    return {
      commentUploadUrl: ''
    };
  },
  methods: {
    ...mapActions('modal', ['showFailModal']),
    fileAttached(event) {
      if (!this.validateInput(event.target.value)) {
        this.clearAttachInput();
        return;
      }
      if (event.target.files[0].size > 5122059) {
        this.clearAttachInput();
        this.showFailModal('Fajl ne može biti veći od 5MB');
        return;
      }
      this.commentUploadUrl = URL.createObjectURL(event.target.files[0]);
      this.$emit('fileAttached', {
        file: event.target.files[0]
      });
    },
    onDrop(e) {
      e.stopPropagation();
      e.preventDefault();
      var files = e.dataTransfer.files;
      if (!this.validateDropInput(files[0].type)) {
        this.clearAttachInput();
        return;
      }
      if (files[0].size > 5122059) {
        this.clearAttachInput();
        this.showFailModal('Fajl ne može biti veći od 5MB');
        return;
      }
      this.commentUploadUrl = URL.createObjectURL(files[0]);
      this.$emit('fileAttached', {
        file: files[0]
      });
    },
    validateInput(value) {
      let allowedExtensions = ['jpg', 'jpeg', 'png'];
      let extension = value.substring(value.lastIndexOf('.') + 1, value.length);
      return allowedExtensions.indexOf(extension) > -1;
    },
    validateDropInput(value) {
      let allowedExtensions = ['jpg', 'jpeg', 'png'];
      let extension = value.substring(value.lastIndexOf('/') + 1, value.length);
      console.log(extension);
      return allowedExtensions.indexOf(extension) > -1;
    },
    clearAttachInput() {
      this.$emit('removedUploadedImg');
      this.$refs.commentUpload.value = '';
      this.commentUploadUrl = '';
    }
  }
};
</script>
<style lang="scss">
.upload-area {
  .circle {
    border-radius: 50%;
  }
  &.circle .uploaded-pic {
    border-radius: 50%;
  }
  &.circle .hover-shadow {
    border-radius: 50%;
  }
  //   background-color: var(--grey-lighten);
  display: inline-block;
  overflow: hidden;
  position: relative;
  .add-img-wrapper {
    display: flex;
    flex-direction: column;
    border: 2px dashed var(--primary-color);
    width: inherit;
    height: inherit;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    text-align: center;
    color: var(--grey);
  }

  .attached-img-wrapper {
    width: inherit;
    height: inherit;
    display: flex;
    flex-direction: column;
    .hover-shadow {
      width: inherit;
      height: inherit;
      opacity: 0;
      background-color: rgba(0, 0, 0, 0.41);
      position: absolute;
      transition: opacity 0.2s;
      display: flex;
      justify-content: center;
      align-items: center;

      i {
        color: white;
      }
    }

    .uploaded-pic {
      height: inherit;
      width: inherit;
      object-fit: cover;
    }
    .imageBorder {
      border-radius: 8px;
    }
  }

  .attached-img-wrapper:hover {
    .hover-shadow {
      opacity: 1;
    }
  }
  .img-icon {
    font-size: 2rem;
    color: var(--grey);
    transition: color 0.25s;
    display: block;
  }

  .text {
    transition: color 0.25s;
  }
}

.upload-area:hover {
  cursor: pointer;
  .img-icon,
  .text {
    color: var(--primary-color);
  }
}
</style>
